import { getRequest } from '@/core';
import { customers } from '@/requests';

export default async function getCustomerByNumberRequest(customerNumber) {
	let url = customers.getByNumberPath(customerNumber);
	let response = await getRequest(url);
	return response;
}
